import { API_STATUS } from "../../../constants/apiStatus";

export const analyticsSliceInitialState = {
  analytics: null,
  recentActivity: null,
  selectedDays: 30,
  selectedActivityWeeks: 1,
  error: null,
  apiStatus: {
    getAnalytics: API_STATUS.IDLE,
    getRecentActivity: API_STATUS.IDLE,
    getUserStats: API_STATUS.IDLE,
    getRevenueStats: API_STATUS.IDLE,
    getSubscriptionStats: API_STATUS.IDLE,
    getUsageStats: API_STATUS.IDLE,
  },
};
